import { Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css']
})
export class CardsComponent implements OnInit {
  Accuracy:any;
  scanned = 0;
  classified = 0;
  issues: any;
  scannedon = '';
  classifiedOn = '';
  verifiedOn = '';
  verified = 0;
  pending = 0;
  autoClassified = 0;



  constructor(private http: HttpClient) {
  }

  ngOnInit() {


    this.http.get('/issue/api/bytype/0/1').subscribe(data => {
      this.issues = data;
      this.autoClassified += this.issues.length;
    });


    this.http.get('/issue/api').subscribe(data => {
      this.issues = data;
      this.scanned += this.issues.length;
      this.scannedon = this.issues[this.issues.length - 1].ScannedOn;
    });
    this.http.get('issue/api/byclassstatus/1').subscribe(data => {
      this.issues = data;
      this.classified += this.issues.length;
      this.classifiedOn = this.issues[this.issues.length - 1].classifiedOn;
    });
    this.http.get('issue/api/bystatus/1/1').subscribe(data => {
      this.issues = data;
      this.verified += this.issues.length;
      this.verifiedOn = this.issues[this.issues.length - 1].ApprovedOn;
    });
    this.http.get('issue/api/bystatus/1/0').subscribe(data => {
      this.issues = data;
      this.pending += this.issues.length;
    });


    setTimeout(() => {this.Accuracy = parseFloat(String((this.autoClassified / this.verified) * 100)).toFixed(0); }, 500);
  }


}






// WEBPACK FOOTER //
// ./src/app/cards/cards.component.ts